module.exports = __webpack_public_path__ + "img/top1-1.c9644506.png";